export const REFRESH_TOKEN_CODES = {
  RT001: 'refreshTokenNotExist',
  RT002: 'refreshTokenExpired',
  RT003: 'refreshTokenInvalid',
};
